// extracted by mini-css-extract-plugin
export default {"couponCode":"Coupons_couponCode__RcNcM","couponBody":"Coupons_couponBody__Kfwoo","applyBody":"Coupons_applyBody__rpJ3m","applyBtn":"Coupons_applyBtn__40oqI"};